import SDKConfig from '../../SDKConfig';
import { LIVE_DURATION, MonitoredMediaEvents } from '../constants';
import { EventReport, PlayerEventReporter } from './interfaces';

const IS_PORTAL = (config: SDKConfig) => config.integration.name === 'portal';
const code = MonitoredMediaEvents.durationchange.code;

export const isValidDuration = (dur?: unknown): boolean => {
  return typeof dur === 'number' && (dur === -1 || dur > 0);
};

/**
 * We only want to report if it's a synthetic event or if the durations are
 * different. HACK: If duration is not set we return true because of the
 * portal HACK
 *
 * @param stateDur - last seen duration
 * @param dur - current duration
 * @param s - true it this is should be reported even if the duration hasn't
 * changed.
 * @returns true if this should be reported.
 */
export const isReportable = (
  stateDur?: number,
  dur?: number,
  s?: true
): boolean => {
  return (dur && s) || !(dur && stateDur && dur == stateDur);
};

const durationChangeHandler = (
  event: EventReport,
  reporter: PlayerEventReporter
): boolean => {
  if (event.e != code) {
    return false;
  }
  const eventState = reporter.localState.event;
  if (!isReportable(eventState.duration, event.dur, event.s)) {
    delete event.dur;
    return true;
  }
  reporter.localState.event.duration = event.dur;
  const isValid = isValidDuration(event.dur);
  if (isValid) {
    reporter.localState.event.duration = event.dur;
    reporter.state.hasSeenDuration = true;
  }
  if (reporter.state.ignoreDurationChange && !event.s) {
    return true;
  }
  // HACK: Only use first durationchange event for portal, and force the
  // duration to be live. This works around video-react's misbehavior of using
  // an ever-incrementing finite duration for a live event
  if (IS_PORTAL(reporter.sdkConfig)) {
    reporter.state.ignoreDurationChange = true;
    event.dur = LIVE_DURATION;
    return false;
  }
  return !isValid;
};

export default durationChangeHandler;
